import * as API_CONSTANT from "../constants";

export const getAllCompany = () =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/company/get/all`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({}),
  }).then((res) => res.json());

export const getCompanyThruCoid = (coid) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/company/get/coid`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify({ coid }),
  }).then((res) => res.json());

export const createCompany = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/company/create`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());

export const updateCompany = (items) =>
  fetch(`${API_CONSTANT.cnp_v1_fe_path}/company/update`, {
    method: "POST",
    headers: API_CONSTANT.headers,
    body: JSON.stringify(items),
  }).then((res) => res.json());
